import { Tab } from '@headlessui/react';
import clsx from 'clsx';
import React, { useMemo } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Outlet, useLocation, useNavigate } from 'react-router';

type TabData = {
  path: string;
  name: string;
};

type RoutedTabsProps = {
  pathPrefix: string;
  tabs: TabData[];
};

function useRouteIndex(pathPrefix: string, tabs: TabData[]) {
  const location = useLocation();

  return useMemo(() => {
    const index = tabs.findIndex(
      (tab) => location?.pathname.startsWith(`${pathPrefix}${tab.path}`),
    );

    return index >= 0 ? index : 0;
  }, [tabs, location.pathname]);
}

export default function RoutedTabs({ pathPrefix = '', tabs }: RoutedTabsProps) {
  const navigate = useNavigate();
  const selectedIndex = useRouteIndex(pathPrefix, tabs);

  return (
    <Tab.Group
      selectedIndex={selectedIndex}
      onChange={(index: number) => {
        navigate(`${pathPrefix}${tabs[index].path}`);
      }}>
      <Tab.List className="flex pl-2 -mb-px space-x-8">
        {tabs.map((tab) => (
          <Tab
            key={tab.name}
            className={({ selected }) =>
              clsx(
                selected
                  ? 'border-oncolensOrange-500 text-oncolensOrange-600'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm',
              )
            }>
            {tab.name}
          </Tab>
        ))}
      </Tab.List>
      <Outlet />
    </Tab.Group>
  );
}
